<div class="modal-content">
  <!-- Cabeçalho do Modal com título e botão de fechar -->
  <div class="modal-header">
    <h5 class="modal-title">
      {{ customMessage ? "Editar Mensagem" : "Adicionar Mensagem" }}
    </h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Fechar"
      (click)="activeModal.dismiss()"
    ></button>
  </div>

  <div class="modal-body p-4">
    <form [formGroup]="customMessageForm" (ngSubmit)="onSubmit()">
      <!-- Campo Nome -->
      <div class="mb-3">
        <label class="form-label">Título</label>
        <input
          class="form-control"
          placeholder="Digite o título da mensagem"
          type="text"
          formControlName="titulo"
          [ngClass]="{
            'is-invalid':
              customMessageForm.controls.titulo.touched &&
              customMessageForm.controls.titulo.errors,
          }"
        />
        <div
          class="invalid-feedback"
          *ngIf="
            customMessageForm.controls.mensagem.touched &&
            customMessageForm.controls.mensagem.errors
          "
        >
          O nome é obrigatório.
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label">Mensagem</label>
        <input
          class="form-control"
          placeholder="Digite a mensagem"
          type="text"
          formControlName="mensagem"
          [ngClass]="{
            'is-invalid':
              customMessageForm.controls.mensagem.touched &&
              customMessageForm.controls.mensagem.errors,
          }"
        />
        <div
          class="invalid-feedback"
          *ngIf="
            customMessageForm.controls.mensagem.touched &&
            customMessageForm.controls.mensagem.errors
          "
        >
          O nome é obrigatório.
        </div>
      </div>
      <!-- Botão de Enviar -->
      <div class="text-end">
        <button type="submit" class="btn btn-success w-md">Salvar</button>
      </div>
    </form>
  </div>
</div>
